import * as Sentry from '@sentry/react';

// Only the opaque Clerk id. An email or a name here would put personal data into a US
// processor, which is the opposite of what the redaction boundary is for; the id gives
// "how many distinct users hit this error" without identifying any of them.
export const setSentryUser = (userId: string | undefined) => {
  Sentry.setUser(userId ? { id: userId } : null);
};

export const useSentryLogger = () => {
  const logInfo = (message: string, page: string, component = '') => {
    Sentry.captureMessage(message, {
      level: 'info',
      contexts: {
        component: {
          name: component,
          page,
        },
      },
    });
  };

  const logException = (
    error: any,
    message: string,
    page: string,
    component = '',
  ) => {
    Sentry.captureException(error, {
      contexts: {
        component: {
          name: component,
          page,
        },
        message: {
          info: message,
        },
      },
    });
  };

  return {
    logInfo,
    logException,
  };
};
